import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const collectedAnimalObject = z.object({
  id: z.string().uuid(),
  incentiveId: z.string().uuid(),
  earringNumber: z.number().int(),
  species: z.string().nullish(),
  weight: z.number().nullish(),
  unitValue: z.number().nullish(),
  discountValue: z.number().nullish(),
  clientId: z.number().int().nullish(),
  sourceFilter: z.string().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type CollectedAnimalType = z.infer<typeof collectedAnimalObject>

export const propertyMap = {
  id: sql`id`,
  incentiveId: sql`incentive_id`,
  earringNumber: sql`earring_number`,
  species: sql`species`,
  weight: sql`weight`,
  unitValue: sql`unit_value`,
  discountValue: sql`discount_value`,
  sourceFilter: sql`source_filter`,
  clientId: sql`client_id`,
  insertUserId: sql`insert_user_id`,
  editUserId: sql`edit_user_id`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
}
